import React, { ReactNode } from 'react';
import clsx from 'clsx';
import { Typography } from 'ui-components';
import { useTranslation } from 'react-i18next';

import useStyles from './IkeOrIkzeMobile.style';

interface MobileComparisonRowProps {
  categoryKey: string;
  ikeContent: ReactNode;
  ikzeContent: ReactNode;
  hasBackground?: boolean;
}

const MobileComparisonRow: React.FC<MobileComparisonRowProps> = ({
  categoryKey,
  ikeContent,
  ikzeContent,
  hasBackground = false,
}) => {
  const { t } = useTranslation('ike-or-ikze');
  const c = useStyles({});

  const rowClass = hasBackground ? c.rowWithBackground : '';

  return (
    <div className={rowClass}>
      <div className={c.noteCell}>
        <Typography variant="body2" textColor='greys.60'>{t(categoryKey)}</Typography>
      </div>

      <div className={c.row}>
        <div className={c.itemCell}>
          <Typography variant="body2" className={c.productItemText}>
            {ikeContent}
          </Typography>
        </div>
        <div className={c.itemCell}>
          <Typography variant="body2" className={clsx(c.productItemText, c.rightElementWithBorder)}>
            {ikzeContent}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default MobileComparisonRow;
